module.exports = __webpack_public_path__ + "static/media/gif_final.277ac30d.gif";